module.exports = __webpack_public_path__ + "img/28_49.f6827b0f.png";